function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M125 0C56.075 0 0 56.075 0 125V176.787C0 189.587 11.2125 200 25 200H37.5C40.8152 200 43.9946 198.683 46.3388 196.339C48.683 193.995 50 190.815 50 187.5V123.213C50 119.897 48.683 116.718 46.3388 114.374C43.9946 112.029 40.8152 110.713 37.5 110.713H26.15C33.1 62.3375 74.725 25 125 25C175.275 25 216.9 62.3375 223.85 110.713H212.5C209.185 110.713 206.005 112.029 203.661 114.374C201.317 116.718 200 119.897 200 123.213V200C200 213.788 188.788 225 175 225H150V212.5H100V250H175C202.575 250 225 227.575 225 200C238.788 200 250 189.587 250 176.787V125C250 56.075 193.925 0 125 0Z",
    fill: "white",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 0C56.075 0 0 56.075 0 125V176.787C0 189.587 11.2125 200 25 200H37.5C40.8152 200 43.9946 198.683 46.3388 196.339C48.683 193.995 50 190.815 50 187.5V123.213C50 119.897 48.683 116.718 46.3388 114.374C43.9946 112.029 40.8152 110.713 37.5 110.713H26.15C33.1 62.3375 74.725 25 125 25C175.275 25 216.9 62.3375 223.85 110.713H212.5C209.185 110.713 206.005 112.029 203.661 114.374C201.317 116.718 200 119.897 200 123.213V200C200 213.788 188.788 225 175 225H150V212.5H100V250H175C202.575 250 225 227.575 225 200C238.788 200 250 189.587 250 176.787V125C250 56.075 193.925 0 125 0Z",
    fill: "white",
    fillOpacity: 0.7,
    style: {
      mixBlendMode: "overlay"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector7);
export default __webpack_public_path__ + "static/media/Vector (7).8056dc007e320bedba9a7c9754a6f8a6.svg";
export { ForwardRef as ReactComponent };